module.exports = __webpack_public_path__ + "img/clockwise.101b6c4e.svg";